module.exports = __webpack_public_path__ + "pc/img/rec_24.891ed1a0.svg";